import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/HomeMain"),
      children: []
    },
    {
      name: "news",
      path: "/tin-tuc/:slug",
      component: () => import("@/views/NewsDetail"),
      props: true
    },
    {
      name: "news-list",
      path: "/tin-tuc",
      props: true,
      component: () => import("@/views/NewsList")
    },
    {
      name: "introduce",
      path: "/gioi-thieu",
      props: true,
      component: () => import("@/views/Introduce")
    },
    {
      name: "page",
      path: "/:slug",
      props: true,
      component: () => import("@/views/Page")
    },
    {
      name: "product",
      path: "/san-pham",
      props: true,
      component: () => import("@/views/Product")
    },
    {
      name: "contact",
      path: "/lien-he",
      props: true,
      component: () => import("@/views/Contact")
    },
    {
      name: "productByCategory",
      path: "/:slug/san-pham",
      props: true,
      component: () => import("@/views/ProductsByCategory")
    },
    {
      name: "productDetail",
      path: "/san-pham/:slug",
      props: true,
      component: () => import("@/views/ProductDetail")
    },
    {
      name: "productSearching",
      path: "/tim-kiem",
      props: route => ({ keyword: route.query.keyword }),
      component: () => import("@/views/Search")
    },
    {
      name: "support",
      path: "/tu-van",
      props: () => ({ slug: "tu-van" }),
      component: () => import("@/views/NewsCategory")
    },
    {
      name: "service",
      path: "/dich-vu",
      props: () => ({ slug: "dich-vu" }),
      component: () => import("@/views/NewsCategory")
    }
  ],
  scrollBehavior() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 500);
    })
  }
});
